import ConfigProvider from "./ConfigProvider";
class LogLocalStorageOut {
  configProvider;
  logBuffer;
  logStatus;

  constructor() {
    this.configProvider = new ConfigProvider();
    this.CreateLogsInLocalStorageIfNotExists();
    this.CreateLogBufferInLocalStorageIfNotExists();
    this.CreateLogStatusInLocalStorageIfNotExists();
  }

  CreateLogsInLocalStorageIfNotExists() {
    for (var i = 1; i <= this.configProvider.GetLogCount(); i++) {
      var actualLogName = `Log${i}`;
      var actualLog = localStorage.getItem(actualLogName);
      if (!!!actualLog) {
        localStorage.setItem(actualLogName, "");
      }
    }
  }

  CreateLogBufferInLocalStorageIfNotExists() {
    this.logBuffer = localStorage.getItem("LogBuffer");
    if (!!!this.logBuffer) {
      this.logBuffer = "";
      localStorage.setItem("LogBuffer", this.logBuffer);
    }
  }

  CreateLogStatusInLocalStorageIfNotExists() {
    this.logStatus = parseInt(localStorage.getItem("LogStatus"));
    if (!!!this.logStatus) {
      this.logStatus = 1;
      localStorage.setItem("LogStatus", this.logStatus);
    }
  }

  Save(msg) {
    if (this.CheckIfMsgFitsInLogBuffer(msg)) {
      let actualLogName = `Log${this.logStatus}`;
      let actualLog = localStorage.getItem(actualLogName);
      if (this.CheckIfLogBufferFitsInLog(actualLog)) {
        this.ChangeLogStatus();
        actualLogName = `Log${this.logStatus}`;
        actualLog = "";
      }
      this.UpdateLog(actualLog, actualLogName);
    }
    this.UpdateLogBuffer(msg);
  }

  CheckIfMsgFitsInLogBuffer(msg) {
    return (
      this.logBuffer.length + msg.length > this.configProvider.GetBufferSize()
    );
  }

  CheckIfLogBufferFitsInLog(actualLog) {
    return (
      actualLog.length + this.logBuffer.length >
      this.configProvider.GetLogSize()
    );
  }

  ChangeLogStatus() {
    if (this.logStatus === this.configProvider.GetLogCount())
      this.logStatus = 1;
    else this.logStatus += 1;
    localStorage.setItem("LogStatus", this.logStatus);
  }

  UpdateLog(actualLog, actualLogName) {
    actualLog = actualLog + this.logBuffer;
    localStorage.setItem(actualLogName, actualLog);
    this.logBuffer = "";
  }

  UpdateLogBuffer(msg) {
    this.logBuffer = this.logBuffer + msg + "\n";
    localStorage.setItem("LogBuffer", this.logBuffer);
  }
}

export default LogLocalStorageOut;
